import { marketingService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    marketerSettingStatus: 'loading',
    data_status: 'loading',
    data: {
        marketer_balance: 0,
        marketer_profit_amount: 0,
        marketing_level: 0,
        clicks_number: 0,
        subsets_number: 0,

        marketers_profit_amount: 0,
        manage_balance: 0,
        settlemented_amount: 0,
        marketers_number: 0,
        registered_with_referer: 0,
        total_clicks: 0,
    },
    marketing_tools: {},
    marketing_setting: {},
    marketer_specific_setting: {
        show_transactions_reports_status: 0,
        show_settlements_reports_status: 0,
        subsets_for_settlements_report: '',
        subsets_for_psp_report: '',
        subsets_for_app_report: ''
    },
    marketer_subsets: {},
    subsetPSPReportStatistics: {
        terminal_title: '-',
        last_updated: '-',
        total_transactions: 0,
        number: 0,
    },
    subsetAppReportStatistics: {
        total_transactions: 0,
        number: 0,
    },
    subsetShops: {},
    marketingStatistics: {},
    posVisitor: []
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, data) {
        state.status = 'success'
        state.data = data
    },
    successFetchSetting(state, marketing_setting) {
        state.status    = 'success'
        state.marketing_setting = marketing_setting
    },
    successFetchSpecificMarketerSetting(state, marketer_specific_setting) {
        state.marketerSettingStatus = 'success-specific-marketer'
        state.marketer_specific_setting = marketer_specific_setting
    },
    fetchMarketingTools(state,marketing_tools) {
        state.status = 'success'
        state.marketing_tools =marketing_tools
    },
    fetchMarketerSubsets(state, marketer_subsets) {
        state.status = 'success-subsets'
        state.marketer_subsets = marketer_subsets
    },
    subsetPSPReportStatistics(state, subsetPSPReportStatistics) {
        state.status = 'success-psp-report'
        state.subsetPSPReportStatistics = subsetPSPReportStatistics
    },
    subsetAppReportStatistics(state, subsetAppReportStatistics) {
        state.status = 'success-subsets'
        state.subsetAppReportStatistics = subsetAppReportStatistics
    },
    subsetShops(state, subsetShops) {
        state.status = 'success-psp-report'
        state.subsetShops = subsetShops
    },
    fail(state) {
        state.status = 'fail'
        state.data = []
        state.marketing_setting = []
    },
    MarketingStatistics(state, data) {
        state.marketingStatistics = data
    },
    fetchPosVisitor(state, data) {
        state.posVisitor = data
    }
}

const getters = {
    status: ({status}) => status,
    marketerSettingStatus: ({marketerSettingStatus}) => marketerSettingStatus,
    data: ({data}) => data,
    marketing_setting: ({marketing_setting}) => marketing_setting,
    marketer_specific_setting: ({marketer_specific_setting}) => marketer_specific_setting,
    marketing_tools : ({marketing_tools}) => marketing_tools,
    marketer_subsets: ({marketer_subsets}) => marketer_subsets,
    subsetPSPReportStatistics: ({subsetPSPReportStatistics}) => subsetPSPReportStatistics,
    subsetAppReportStatistics: ({subsetAppReportStatistics}) => subsetAppReportStatistics,
    subsetShops: ({subsetShops}) => subsetShops,
    pos_marketing_statistics: (state) => state.marketingStatistics,
    pos_visitor: (state) => state.posVisitor
}

const actions = {
    fetchData({commit}, query) {
        commit('loading')
        return marketingService.fetchData(query)
            .then(response => {
                commit('success', response.data.data)
            })
    },
    fetchSubsets({commit}, query) {
        commit('loading')
        return marketingService.showSubsets()
            .then(response => {
                commit('success', response.data.data)
            })
    },
    fetchSetting({commit}) {
        commit('loading')
        return marketingService.fetchSetting()
            .then(response => {
                commit('successFetchSetting', response.data.data)
            })
    },
    fetchSpecificMarketerSetting({commit}, hashid) {
        commit('loading')
        return marketingService.fetchSpecificMarketerSetting(hashid)
            .then(response => {
                commit('successFetchSpecificMarketerSetting',response.data.data)
            })
    },
    fetchMarketingTools({commit}) {
        commit('loading')
        return marketingService.fetchMarketingTools()
            .then(response => {
                commit('fetchMarketingTools',response.data.data)
            })
    },
    fetchMarketerSubsets({commit}, hashid) {
        return marketingService.fetchMarketerSubsets(hashid)
            .then(response => {
                commit('fetchMarketerSubsets', response.data.data.data)
            })
    },
    fetchPSPReportStatistics({commit}, params) {
        return marketingService.fetchPSPReportStatistics(params)
            .then(response => {
                commit('subsetPSPReportStatistics', response.data.data)
            })
    },
    fetchAppReportStatistics({commit}, hashid) {
        return marketingService.fetchAppReportStatistics(hashid)
            .then(response => {
                commit('subsetAppReportStatistics', response.data.data)
            })
    },
    fetchSubsetTerminals({commit}, hashid) {
        return marketingService.fetchSubsetTerminals(hashid)
            .then(response => {
                commit('subsetShops', response.data.data)
            })
    },
    fetchPosMarketingStatistics({commit},data) {
        return marketingService.getPosStatistics(data).then(response => {
            commit('MarketingStatistics', response.data.data)
        })
    },
    fetchPosVisitor({commit}) {
        return marketingService.getPosVisitor().then(response => {
            commit('fetchPosVisitor', response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}